import { FC } from "react";
import Head from "next/head";

interface DocumentTitleProps {
  title?: string;
}

const baseTitle = process.env.NEXT_PUBLIC_TITLE;

const DocumentTitle: FC<DocumentTitleProps> = ({ title = null }) => {
  title = title ? `${title} | ${baseTitle}` : baseTitle;

  return (
    <Head>
      <title>{title}</title>
    </Head>
  );
};

export default DocumentTitle;
